import Event from './Event.js'

class FeeExpected extends Event {
    get fee_cancel(){
        let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.parent_id === this.id)&&(rel.child_type==='FeeCancel'))||{}).child_id
        if(value){
            return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
        } else {
            return null
        }
    }
    get feePayment(){
        return (this.fee_cancel||{}).fee_payment
    }

    get linked(){
        return this.fee_cancel != null
    }

    // FeeExpected should always be matched with a FeePayment
    get should_be_linked() {
        return true
    }
}
export default FeeExpected
